(() => {
  // Preserve the app's existing controls and event listeners by moving its root.
  const selector = '#cbb-frequently-bought-container, .cbb-frequently-bought-container';
  let queued = false;
  function placeBundle() {
    queued = false;
    const slot = document.querySelector('[id^="MainProduct-"] [data-gos-bundle-slot]');
    if (!slot) return;
    document.querySelectorAll(selector).forEach((bundle) => {
      // Only move the outer root when an app uses nested matching containers.
      if (bundle.parentElement?.closest(selector) || bundle.parentElement === slot) return;
      if (bundle.contains(document.activeElement)) return;
      slot.appendChild(bundle);
    });
  }
  function schedulePlacement() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(placeBundle);
  }
  // Keep handling delayed loading, replacement roots, and variant reinitialization.
  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) schedulePlacement();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedulePlacement);
  document.addEventListener('focusout', schedulePlacement);
  schedulePlacement();
})();
